import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Club } from "../../../types-business/Clubs";
import EmployeesReportComp from "../../components/employeesReportComp";
import Layout from "../../components/layout";

interface Props {
  userContext: { clubSessionId: any };
}

interface State {
  clubs: Club[];
}

class EmployeesReportContainer extends React.Component<Props, State> {
  componentDidMount() {}

  render() {
    return (
      <main>
        <Helmet title="Reporte de empleados" />
        <Layout>
          <EmployeesReportComp userContext={this.props.userContext} />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeesReportContainer);
